import {
  Companion_instance204uo7fmjm4u6 as Companion_instance,
  SetupFailed2fc202771pbwx as SetupFailed,
} from './supportModels.mjs';
import {
  properties1qnxlk10mmfrs as properties,
  get_serializableAnnotations132wwdaanmitj as get_serializableAnnotations,
  SerializableProperty3ugfzrmvjw266 as SerializableProperty,
} from '../../../lightning-server-shared/com/lightningkite/serialization/SerializableProperty.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
import { GeneratedSerializer1f7t7hssdd2ws as GeneratedSerializer } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/internal/PluginHelperInterfaces.mjs';
import { isInterface3d6p8outrmvmk as isInterface } from '../../../kotlin-kotlin-stdlib/kotlin/js/typeCheckUtils.mjs';
import { KSerializerzf77vz1967fq as KSerializer } from '../../../kotlinx-serialization-kotlinx-serialization-core/kotlinx/serialization/KSerializer.mjs';
import { lazy2hsh8ze7j6ikd as lazy } from '../../../kotlin-kotlin-stdlib/kotlin/kotlin.mjs';
import { KProperty1ca4yb4wlo496 as KProperty1 } from '../../../kotlin-kotlin-stdlib/kotlin/reflect/KPropertyJs.mjs';
import { getPropertyCallableRef3hckxc0xueiaj as getPropertyCallableRef } from '../../../kotlin-kotlin-stdlib/kotlin/js/reflectRuntime.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { initMetadataForObject1cxne3s9w65el as initMetadataForObject } from '../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function prepareSetupFailedFields() {
  // Inline function 'kotlin.arrayOf' call
  // Inline function 'kotlin.js.unsafeCast' call
  // Inline function 'kotlin.js.asDynamic' call
  var props = [SetupFailed__id_getInstance(), SetupFailed_intent_getInstance(), SetupFailed_customer_getInstance(), SetupFailed_cancelReason_getInstance()];
  var tmp = Companion_instance.k2a();
  properties(tmp, (it) => props);
}
function SetupFailed__id$name$delegate$lambda() {
  return Companion_instance.k2a().az().v11(0);
}
function SetupFailed__id$_get_name_$ref_q0f5gi() {
  return (p0) => p0.i20();
}
function SetupFailed__id$serializer$delegate$lambda() {
  var tmp = Companion_instance.k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[0];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function SetupFailed__id$_get_serializer_$ref_lh69kn() {
  return (p0) => p0.h2j();
}
function SetupFailed__id$annotations$delegate$lambda() {
  return Companion_instance.k2a().az().x11(0);
}
function SetupFailed__id$_get_annotations_$ref_aeooh9() {
  return (p0) => p0.bz();
}
var SetupFailed__idClass;
function SetupFailed__id() {
  if (SetupFailed__idClass === VOID) {
    class $ {
      constructor() {
        SetupFailed__id_instance = this;
        var tmp = this;
        tmp.m81_1 = lazy(SetupFailed__id$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.n81_1 = lazy(SetupFailed__id$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.o81_1 = lazy(SetupFailed__id$annotations$delegate$lambda);
      }
      i20() {
        var tmp0 = this.m81_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, SetupFailed__id$_get_name_$ref_q0f5gi(), null);
        return tmp0.f2();
      }
      p81(receiver) {
        return receiver.q81_1;
      }
      k2j(receiver) {
        return this.p81(receiver instanceof SetupFailed() ? receiver : THROW_CCE());
      }
      u81(receiver, value) {
        return receiver.v81(value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof SetupFailed() ? receiver : THROW_CCE();
        return this.u81(tmp, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.n81_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, SetupFailed__id$_get_serializer_$ref_lh69kn(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.o81_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, SetupFailed__id$_get_annotations_$ref_aeooh9(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'SetupFailed__id', VOID, VOID, [SerializableProperty()]);
    SetupFailed__idClass = $;
  }
  return SetupFailed__idClass;
}
var SetupFailed__id_instance;
function SetupFailed__id_getInstance() {
  if (SetupFailed__id_instance === VOID)
    new (SetupFailed__id())();
  return SetupFailed__id_instance;
}
function SetupFailed_intent$name$delegate$lambda() {
  return Companion_instance.k2a().az().v11(1);
}
function SetupFailed_intent$_get_name_$ref_qz3dzm() {
  return (p0) => p0.i20();
}
function SetupFailed_intent$serializer$delegate$lambda() {
  var tmp = Companion_instance.k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[1];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function SetupFailed_intent$_get_serializer_$ref_hxu7f9() {
  return (p0) => p0.h2j();
}
function SetupFailed_intent$annotations$delegate$lambda() {
  return Companion_instance.k2a().az().x11(1);
}
function SetupFailed_intent$_get_annotations_$ref_3zt0uf() {
  return (p0) => p0.bz();
}
var SetupFailed_intentClass;
function SetupFailed_intent() {
  if (SetupFailed_intentClass === VOID) {
    class $ {
      constructor() {
        SetupFailed_intent_instance = this;
        var tmp = this;
        tmp.w81_1 = lazy(SetupFailed_intent$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.x81_1 = lazy(SetupFailed_intent$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.y81_1 = lazy(SetupFailed_intent$annotations$delegate$lambda);
      }
      i20() {
        var tmp0 = this.w81_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, SetupFailed_intent$_get_name_$ref_qz3dzm(), null);
        return tmp0.f2();
      }
      p81(receiver) {
        return receiver.r81_1;
      }
      k2j(receiver) {
        return this.p81(receiver instanceof SetupFailed() ? receiver : THROW_CCE());
      }
      u81(receiver, value) {
        return receiver.v81(VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof SetupFailed() ? receiver : THROW_CCE();
        return this.u81(tmp, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.x81_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, SetupFailed_intent$_get_serializer_$ref_hxu7f9(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.y81_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, SetupFailed_intent$_get_annotations_$ref_3zt0uf(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'SetupFailed_intent', VOID, VOID, [SerializableProperty()]);
    SetupFailed_intentClass = $;
  }
  return SetupFailed_intentClass;
}
var SetupFailed_intent_instance;
function SetupFailed_intent_getInstance() {
  if (SetupFailed_intent_instance === VOID)
    new (SetupFailed_intent())();
  return SetupFailed_intent_instance;
}
function SetupFailed_customer$name$delegate$lambda() {
  return Companion_instance.k2a().az().v11(2);
}
function SetupFailed_customer$_get_name_$ref_i9vsmo() {
  return (p0) => p0.i20();
}
function SetupFailed_customer$serializer$delegate$lambda() {
  var tmp = Companion_instance.k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[2];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function SetupFailed_customer$_get_serializer_$ref_vot3jd() {
  return (p0) => p0.h2j();
}
function SetupFailed_customer$annotations$delegate$lambda() {
  return Companion_instance.k2a().az().x11(2);
}
function SetupFailed_customer$_get_annotations_$ref_s67shx() {
  return (p0) => p0.bz();
}
var SetupFailed_customerClass;
function SetupFailed_customer() {
  if (SetupFailed_customerClass === VOID) {
    class $ {
      constructor() {
        SetupFailed_customer_instance = this;
        var tmp = this;
        tmp.z81_1 = lazy(SetupFailed_customer$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.a82_1 = lazy(SetupFailed_customer$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.b82_1 = lazy(SetupFailed_customer$annotations$delegate$lambda);
      }
      i20() {
        var tmp0 = this.z81_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, SetupFailed_customer$_get_name_$ref_i9vsmo(), null);
        return tmp0.f2();
      }
      p81(receiver) {
        return receiver.s81_1;
      }
      k2j(receiver) {
        return this.p81(receiver instanceof SetupFailed() ? receiver : THROW_CCE());
      }
      u81(receiver, value) {
        return receiver.v81(VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof SetupFailed() ? receiver : THROW_CCE();
        return this.u81(tmp, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.a82_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, SetupFailed_customer$_get_serializer_$ref_vot3jd(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.b82_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, SetupFailed_customer$_get_annotations_$ref_s67shx(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'SetupFailed_customer', VOID, VOID, [SerializableProperty()]);
    SetupFailed_customerClass = $;
  }
  return SetupFailed_customerClass;
}
var SetupFailed_customer_instance;
function SetupFailed_customer_getInstance() {
  if (SetupFailed_customer_instance === VOID)
    new (SetupFailed_customer())();
  return SetupFailed_customer_instance;
}
function SetupFailed_cancelReason$name$delegate$lambda() {
  return Companion_instance.k2a().az().v11(3);
}
function SetupFailed_cancelReason$_get_name_$ref_sbji34() {
  return (p0) => p0.i20();
}
function SetupFailed_cancelReason$serializer$delegate$lambda() {
  var tmp = Companion_instance.k2a();
  var tmp_0 = (isInterface(tmp, GeneratedSerializer()) ? tmp : THROW_CCE()).r1b()[3];
  return isInterface(tmp_0, KSerializer()) ? tmp_0 : THROW_CCE();
}
function SetupFailed_cancelReason$_get_serializer_$ref_o70zs9() {
  return (p0) => p0.h2j();
}
function SetupFailed_cancelReason$annotations$delegate$lambda() {
  return Companion_instance.k2a().az().x11(3);
}
function SetupFailed_cancelReason$_get_annotations_$ref_nn1723() {
  return (p0) => p0.bz();
}
var SetupFailed_cancelReasonClass;
function SetupFailed_cancelReason() {
  if (SetupFailed_cancelReasonClass === VOID) {
    class $ {
      constructor() {
        SetupFailed_cancelReason_instance = this;
        var tmp = this;
        tmp.c82_1 = lazy(SetupFailed_cancelReason$name$delegate$lambda);
        var tmp_0 = this;
        tmp_0.d82_1 = lazy(SetupFailed_cancelReason$serializer$delegate$lambda);
        var tmp_1 = this;
        tmp_1.e82_1 = lazy(SetupFailed_cancelReason$annotations$delegate$lambda);
      }
      i20() {
        var tmp0 = this.c82_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('name', 1, tmp, SetupFailed_cancelReason$_get_name_$ref_sbji34(), null);
        return tmp0.f2();
      }
      p81(receiver) {
        return receiver.t81_1;
      }
      k2j(receiver) {
        return this.p81(receiver instanceof SetupFailed() ? receiver : THROW_CCE());
      }
      u81(receiver, value) {
        return receiver.v81(VOID, VOID, VOID, value);
      }
      n2j(receiver, value) {
        var tmp = receiver instanceof SetupFailed() ? receiver : THROW_CCE();
        return this.u81(tmp, (!(value == null) ? typeof value === 'string' : false) ? value : THROW_CCE());
      }
      h2j() {
        var tmp0 = this.d82_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('serializer', 1, tmp, SetupFailed_cancelReason$_get_serializer_$ref_o70zs9(), null);
        return tmp0.f2();
      }
      bz() {
        var tmp0 = this.e82_1;
        var tmp = KProperty1();
        // Inline function 'kotlin.getValue' call
        getPropertyCallableRef('annotations', 1, tmp, SetupFailed_cancelReason$_get_annotations_$ref_nn1723(), null);
        return tmp0.f2();
      }
    }
    protoOf($).o2j = get_serializableAnnotations;
    initMetadataForObject($, 'SetupFailed_cancelReason', VOID, VOID, [SerializableProperty()]);
    SetupFailed_cancelReasonClass = $;
  }
  return SetupFailed_cancelReasonClass;
}
var SetupFailed_cancelReason_instance;
function SetupFailed_cancelReason_getInstance() {
  if (SetupFailed_cancelReason_instance === VOID)
    new (SetupFailed_cancelReason())();
  return SetupFailed_cancelReason_instance;
}
//region block: exports
export {
  prepareSetupFailedFields as prepareSetupFailedFields15fzbzwt2ifs4,
};
//endregion

//# sourceMappingURL=SetupFailedFields.mjs.map
